export const GUIDE_QUEST_PANEL_H = 28;
export const GUIDE_QUEST_PANEL_GAP = 4;
export const GUIDE_QUEST_PANEL_TOP_OFFSET = 6;

export interface GuideQuestSlotRect {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
}

export function computeGuideQuestPanelRect(rect: {
  readonly x: number;
  readonly y: number;
  readonly width: number;
}): GuideQuestSlotRect {
  return {
    x: rect.x,
    y: rect.y + GUIDE_QUEST_PANEL_TOP_OFFSET,
    width: rect.width,
    height: GUIDE_QUEST_PANEL_H,
  };
}
